import { FC } from 'react';

import { IconProps } from '../../shared/ui';

export const PieIcon: FC<IconProps> = ({ width = 53, height = 53, fill = '#C00000', classNameRect }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        transform={classNameRect}
        fillRule="evenodd"
        clipRule="evenodd"
        // eslint-disable-next-line max-len
        d="M9.41406 8.44238V1.46113C9.41406 1.17988 9.63281 0.942383 9.91406 0.942383C13.7797 0.942383 16.9141 4.07676 16.9141 7.94238C16.9141 8.22363 16.6766 8.44238 16.3953 8.44238H9.41406ZM0.914062 9.44238C0.914062 5.65176 3.72969 2.51426 7.38281 2.01426C7.67031 1.97363 7.91406 2.20488 7.91406 2.49551V9.94238L12.8047 14.833C13.0141 15.0424 12.9984 15.3861 12.7578 15.5549C11.5328 16.4299 10.0328 16.9424 8.41406 16.9424C4.27344 16.9424 0.914062 13.5861 0.914062 9.44238ZM17.3641 9.94238C17.6547 9.94238 17.8828 10.1861 17.8453 10.4736C17.6047 12.2205 16.7641 13.7736 15.5359 14.9205C15.3484 15.0955 15.0547 15.083 14.8734 14.8986L9.91406 9.94238H17.3641Z"
        fill={fill}
      />
    </svg>
  );
};
